const appInfo = {
  title: "derGefahrensucher GmbH",
};
export default appInfo;
